import { Models } from '../../assets/ts/models';
import NewForm from '../forms/newform/newForm.vue';
const bpmsModel = new Models();

export default {
    data() {
        return {
            loading: false,
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            errorTxt: '',
            model: {
                currentPassword: '',
                newPassword: '',
            },
            isOldSso: payload.isOpenId != true,
            ssoUrl: payload.ssoUrl.toLowerCase() + "/changepassword",
            showChangePassword: payload.showChangePassword
        }
    },
    methods: {
        submit() {
            if (this.currentPassword == null || this.currentPassword == "") {
                this.errorTxt = this.$t('password_setting.messages.currentPassword_is_empty');
            } else {
                if (this.newPassword == null || this.newPassword == "") {
                    this.errorTxt = this.$t('password_setting.messages.newPassword_is_empty');
                } else {
                    if (this.confirmNewPassword == null || this.confirmNewPassword == "") {
                        this.errorTxt = this.$t('password_setting.messages.confirmNewPassword_is_empty');
                    } else {

                        if (this.newPassword != this.confirmNewPassword) {
                            this.errorTxt = this.$t('password_setting.messages.passwords_do_not_match');
                        } else {
                            this.loading = true;

                            if (!this.defineLoginMethod) {
                                this.prepareChangePassword();
                                this.loading = false;
                                bpmsModel.ChangePassword(this.model).done(res => {
                                    console.log(res);
                                    if (res === "1") {
                                        this.errorTxt = "";
                                        var params = {
                                            text: this.$t('messages.sucsses_message'),
                                            type: 'information',
                                            layout: 'center',
                                            timeout: 3000
                                        };
                                        noty(params);
                                    }
                                    else {
                                        
                                        if (res == "-1")
                                            this.errorTxt = this.$t('password_setting.messages.current_password_is_wrong');
                                        else
                                            this.errorTxt = res;// 
                                        return;
                                    }

                                }).fail((err) => {
                                    this.loading = false;


                                    //} else if (err.responseText === '-2') {
                                    //    this.errorTxt = 'ارتباط امن نیست';
                                    //    return
                                    //}
                                    //if (err.responseText === '-3') {
                                    //    this.errorTxt = 'نام کاربری یا کلمه ی عبور خالی می باشد';
                                    //    return

                                    //} else {
                                    //    this.errorTxt = 'لطفا دوباره امتحان کنید';
                                    //    return
                                    //} 
                                });
                            }
                        }
                    }
                }
            }
        },

        prepareChangePassword() {
            this.model.currentPassword = this.currentPassword;
            this.model.newPassword = this.newPassword;
        }
    },
    mounted() {
        $('#confirm_new_password').on('keypress', (e) => {
            if (e.keyCode == 13)
                $('#change-submit').click(); 
        });
    },
    components: { 
        NewForm
    }
}
